import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class extends Controller {
  static targets = ['input'];

  connect() {
    const userId = CurrentUser.id();
    if (userId === CurrentPage.getArticleAuthorId()) {
      this.inputTarget.value = 'Autor:in';
    } else if (userId === CurrentPage.getArticleConversationHostId()) {
      this.inputTarget.value = 'Diskussionsleiter:in';
    }
  }
}
